import React from "react";
import { connect } from "react-redux";
import * as R from "ramda";

import SliderSidebarLayout from "ui-kit/SliderSidebar/View";
import Body from "./Body";

import {
  getters as sliderSidebarGetters,
  actions as sliderSidebarActions
} from "ui-kit/SliderSidebar/model";
import { SIDEBAR_INSTANCE_ID } from "../constants";
import Header from "./Header";
import Footer from "./Footer";
import { noop } from "utils/General";
import { Div } from "components/Base";

import { getters as wrapperGetters } from "Portal/NewPortal/Wrapper/model";

const decorate = R.compose(
  connect(
    (state, props) => ({
      isDrawerOpen: sliderSidebarGetters.isDrawerOpen(state, {
        ...props,
        instanceId: SIDEBAR_INSTANCE_ID
      }),
      flyOverWidth: wrapperGetters.flyOverWidth(state)
    }),
    {
      hideModal: () =>
        sliderSidebarActions.setIsDrawerOpen(false, {
          meta: { instanceId: SIDEBAR_INSTANCE_ID }
        })
    }
  )
);

const MobileMenuFlyOver = ({
  isDrawerOpen = false,
  hideModal = noop,
  handleClickOpenSwitchEvents = noop,
  flyOverWidth = null
}) => {
  return (
    <SliderSidebarLayout
      position="right"
      instanceId={SIDEBAR_INSTANCE_ID}
      style={{
        borderRadius: 0,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}
      width={flyOverWidth}
    >
      <Header hideModal={hideModal} name="Menu" />
      {isDrawerOpen && (
        <Div
          style={{ height: "100%", padding: "4px 20px 24px 20px" }}
          display="column.space-between.center"
        >
          <Body
            hideModal={hideModal}
            handleClickOpenSwitchEvents={handleClickOpenSwitchEvents}
          />
          <Footer />
        </Div>
      )}
    </SliderSidebarLayout>
  );
};

export default decorate(MobileMenuFlyOver);
